module.exports = require("react-input-mask");


//////////////////
// WEBPACK FOOTER
// external "react-input-mask"
// module id = 48
// module chunks = 0